import { CmsObjectWithDefault } from '@components/Cms/types';

export type WalletResultCmsKey = 'ButtonLabel';

export const WalletResultCmsWithDefault: CmsObjectWithDefault<WalletResultCmsKey> = {
    ButtonLabel: {
        cmsId: 368057,
        defaultTranslation: 'Done',
    },
};
